import React from 'react'

export default function Header() {
 
  return (
    <div id='header' className='top-0 text-white p-2 text-xl bg-[#BD1023] mb-10'>ComicsFlix</div>
  )
}
